import _actioncableCjsProductionMin from "./actioncable.cjs.production.min.js";
export { _actioncableCjsProductionMin as default };
export const __esModule = _actioncableCjsProductionMin.__esModule,
  WebsocketProvider = _actioncableCjsProductionMin.WebsocketProvider;